(function() { window.GUID_ff0bea24_5783_4371_bc17_5b46ccd8eddd = { getGuid: function() { return "ff0bea24-5783-4371-bc17-5b46ccd8eddd"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StatGroupContainer extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, '.statgroup-row');
                this.$control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.on('click.' + me.controlId, '.statgroup-row', function (e) {
                    let $this = $(this);
                    let data = $this.data('html');
                    me.Trigger(StatGroupContainer.EventNames.RowClicked, { jqueryEventObject: e, data });
                });
            }
        }
        Controls.StatGroupContainer = StatGroupContainer;
        (function (StatGroupContainer) {
            class Events {
                static RowClicked(param) {
                    Controls.RegisterEvent(StatGroupContainer, EventNames.RowClicked, param);
                }
            }
            StatGroupContainer.Events = Events;
            class EventNames {
            }
            EventNames.RowClicked = "row-click";
            StatGroupContainer.EventNames = EventNames;
        })(StatGroupContainer = Controls.StatGroupContainer || (Controls.StatGroupContainer = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=statgroup-row-container.js.map
